import { render, staticRenderFns } from "./brandValue.vue?vue&type=template&id=fb5b0ac2"
import script from "./brandValue.vue?vue&type=script&lang=js"
export * from "./brandValue.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports